/**
 * @generated SignedSource<<e6dce43d06f3d2af08c93b2e4aded207>>
 * @relayHash a592f32ed82fc34137ac143af8b495ca
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a592f32ed82fc34137ac143af8b495ca

import { ConcreteRequest } from 'relay-runtime';
export type LineType = "EMERGENCY_LINE" | "KIDS_LINE" | "SWICA_OVERFLOW" | "TELE_GENERAL_PRACTITIONER_LINE";
export type useDefaultValuesQuery$variables = {
  extensionId?: string | null;
  skip: boolean;
};
export type useDefaultValuesQuery$data = {
  readonly ch_telephoneLines?: ReadonlyArray<{
    readonly id: string;
    readonly key: string;
    readonly lineType: LineType;
  }>;
};
export type useDefaultValuesQuery = {
  response: useDefaultValuesQuery$data;
  variables: useDefaultValuesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "extensionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "extensionId",
            "variableName": "extensionId"
          }
        ],
        "concreteType": "ch_TelephoneLine",
        "kind": "LinkedField",
        "name": "ch_telephoneLines",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lineType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDefaultValuesQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useDefaultValuesQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "a592f32ed82fc34137ac143af8b495ca",
    "metadata": {},
    "name": "useDefaultValuesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e73f4df2055dc0a64f7507b149c7786d";

export default node;
